import loadable from '@loadable/component'

const routes = [
  {
    path: '/',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-homepage" */ '~/pages/home')
    ),
  },
  {
    path: '/bridgehome',
    exact: true,
    component: loadable(() => import('../pages/bridgeHome')),
  },
  {
    path: '/feedback',
    exact: true,
    component: loadable(() => import('../pages/feedback')),
  },
  {
    path: '/cancelAccount',
    exact: true,
    component: loadable(() => import('../pages/cancelAccount')),
  },
  {
    path: '/report',
    exact: true,
    component: loadable(() => import('../pages/report')),
  },
  {
    path: '/privacyPolicy',
    exact: true,
    component: loadable(() => import('../pages/file/privacyPolicy')),
  },
  {
    path: '/userAgreement',
    exact: true,
    component: loadable(() => import('../pages/file/userAgreement')),
  },
  {
    path: '/inviteRules',
    exact: true,
    component: loadable(() => import('../pages/file/inviteRules')),
  },
  {
    path: '/vipSubscription',
    exact: true,
    component: loadable(() => import('../pages/file/vipSubscription')),
  },
  {
    path: '/sample',
    exact: true,
    component: loadable(() => import('../pages/file/sample')),
  },
  {
    path: '/sendMsgView',
    exact: true,
    component: loadable(() => import('../pages/file/sendMsgView')),
  },
  {
    path: '/share/page',
    exact: true,
    component: loadable(() => import('../pages/share')),
  },
  {
    path: '/invite',
    exact: true,
    component: loadable(() => import('../pages/share/invite')),
  },
  {
    path: '/modelSpace',
    exact: true,
    component: loadable(() => import('../pages/modelSpace')),
  },
  {
    path: '/fastPass',
    exact: true,
    component: loadable(() => import('../pages/youSuTong')),
  },
  {
    path: '/download',
    exact: true,
    component: loadable(() => import('../pages/download')),
  },
  {
    path: '/activity/crush',
    exact: true,
    component: loadable(() => import('../pages/activity/crush')),
  },
  {
    path: '/activity/crushFinal',
    exact: true,
    component: loadable(() => import('../pages/activity/crushFinal')),
  },
  {
    path: '/activity/crushTop5',
    exact: true,
    component: loadable(() => import('../pages/activity/crushTop5')),
  },
  {
    path: '/activity/userGuide',
    exact: true,
    component: loadable(() => import('../pages/activity/userGuide'), {
      ssr: false,
    }),
  },
  {
    path: '/activity/creationRenewalNew',
    exact: true,
    component: loadable(() => import('../pages/activity/creationRenewalNew'), {
      ssr: false,
    }),
  },
  {
    path: '/activity/creationRenewalFinal',
    exact: true,
    component: loadable(
      () => import('../pages/activity/creationRenewalFinal'),
      {ssr: false}
    ),
  },
  {
    path: '/activity/halloween',
    exact: true,
    component: loadable(() => import('../pages/activity/halloween'), {
      ssr: false,
    }),
  },
  {
    path: '*',
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '~/pages/notFound')
    ),
  },
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => routes
